/* eslint-disable react-refresh/only-export-components */
import { Box, TextField, styled } from '@mui/material';

/**
 * Shared styled components for credential sections
 * Extracts common inline sx patterns to improve maintainability
 */

export const LinkText = styled(Box)({
  cursor: 'pointer',
  color: '#0066cc',
  textDecoration: 'underline',
  display: 'inline',
  '&:hover': {
    textDecoration: 'none',
  },
});

export const MonospaceTextarea = styled(TextField)({
  '& .MuiInputBase-input': {
    fontFamily: 'monospace',
    fontSize: '12px',
    lineHeight: 1.4,
  },
});

export const FlexRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

// Extract common sx patterns as reusable constants
export const credentialStyles = {
  text: { fontSize: '13px', mb: 1.5 },
  heading: { fontSize: '14px', fontWeight: 600, mb: 2, color: '#333' },
  helper: { fontSize: '11px', color: '#888', mt: 0.25 },
  monospace: { fontFamily: 'monospace', fontSize: '12px', lineHeight: 1.4 },
  linkText: { cursor: 'pointer', color: '#0066cc', textDecoration: 'underline' },
  flexRow: { display: 'flex', alignItems: 'center', gap: 1 },
} as const;
